// utils/descFormat.ts
const titled = (s?: string | null) => (s ?? '').trim()

// keep if you use elsewhere
export const dash = (a: string, b?: string | null) => (b ? `${a} > ${b}` : a)

// new: ordered de-dupe while keeping truthy values
const dedup = (arr: Array<string | undefined | null>) => arr.filter((v, i, a) => !!v && a.indexOf(v) === i) as string[]

// new: join only non-empty parts with a chosen separator
const joinNonEmpty = (parts: Array<string | undefined>, sep: string) => parts.filter(Boolean).join(sep)

// new: Platform | Channel + Base [+ > Sub]
export const heading = (platform?: string, channel?: string, base?: string, sub?: string) => {
  const leftParts = dedup([titled(platform), titled(channel)])
  const left = leftParts.length ? leftParts.join(' | ') : ''
  const core = joinNonEmpty([left, titled(base)], left && base ? ' ' : '')
  return sub ? `${core} > ${titled(sub)}` : core
}
